import React from "react";
import "./AffirmThankyou.scss"
import { ThankyouScreen } from "screens/thankyouScreen";
import { CardLayout } from "components/cardLayout";
import { amslogo, logo } from 'assets/images';

export interface AffirmThankyouProps {

}

export interface AffirmThankyouState {

}

class AffirmThankyou extends React.Component<AffirmThankyouProps, AffirmThankyouState> {
    constructor(props: AffirmThankyouProps) {
        super(props);
        this.state = {};
        
        // const params = new URLSearchParams(window.location.search);
        // const checkout_token = params.get('checkout_token') || ""; 
        // alert(checkout_token);
    }
    render() {
        return (
            <div>
                <ThankyouScreen
                affirmCard={true}
                />
            </div>
        );
    }
}

export default AffirmThankyou;